import { z } from 'zod/v4';
import {
  CAPA_FINDING_SOURCE_TYPES,
  CAPA_FINDING_URGENCY_LEVELS,
} from '../../constants.js';

/**
 * A DELTA-2311 restricted field (`rootCauseAnalysis`, `genderedImplications`):
 * free text capped to the column width, nullable so a value can be cleared,
 * optional so an unrelated write leaves it untouched.
 */
export const RestrictedFieldSchema = z
  .string()
  .max(4000, 'Value too long')
  .nullable()
  .optional();

export const CreateFindingRequestSchema = z.object({
  title: z.string().min(1, 'Title is required').max(4000, 'Title too long'),
  description: z.string(),
  companyId: z.string().min(1, 'Company ID is required'),
  // ZERO_TOLERANCE is system-generated and cannot be created by hand.
  type: z.enum([
    CAPA_FINDING_SOURCE_TYPES.AUDIT,
    CAPA_FINDING_SOURCE_TYPES.SLCP,
    CAPA_FINDING_SOURCE_TYPES.FACTORY_VISIT,
    CAPA_FINDING_SOURCE_TYPES.OTHER,
  ]),
  /** An audit or SLCP assessment id for those types; free text otherwise. */
  source: z.string().min(1, 'Source is required'),
  urgency: z.enum(CAPA_FINDING_URGENCY_LEVELS),
  impactAreaId: z.string().min(1, 'Impact area ID is required'),
  tags: z.array(z.string()).optional(),
  rootCauseAnalysis: RestrictedFieldSchema,
  genderedImplications: RestrictedFieldSchema,
});
export type CreateFindingRequest = z.infer<typeof CreateFindingRequestSchema>;
